import { TMaterialTableColumns } from '../../../../../components/table/index.types';
import { screenings } from '../../../../../types';
import { Col } from '../../../../../components/layout/layout';
import React from 'react';
import Button from '../../../../../components/control/button/button';
import {
    EButtonSize,
    EButtonType,
} from '../../../../../components/control/button/button.types';
import { Root } from '../screening.styled';
import MaterialTable from '../../../../../components/table';
import useScreeningsGet from '../hooks/use-screenings-get';
import wrapUrlWithServerUrl from '../../../../../utils/fetch/utils/wrap-url-with-server-url';
import endpoints, { EEndpoints } from '../../../../../config/endpoints';
import useScreeningCreatePost from '../hooks/use-screening-create-post';
import { toast } from 'react-toastify';
import useCurrentSessionData from '../../../../../hooks/use-current-session-data';
import timeFormat from 'utils/time-format';

const ScreeningList: React.FC = () => {
    const currentSessionData = useCurrentSessionData();
    const [finalData, setFinalData] = React.useState<
        screenings.TScreeningJob[]
    >([]);

    const downloadFile = (id: string) => {
        const url = wrapUrlWithServerUrl(
            `${endpoints[EEndpoints.screeningDownload](id)}`,
        );
        window.open(url, '_blank');
    };

    let index = 1;
    const columns: TMaterialTableColumns<screenings.TScreeningJob> = [
        {
            width: '50',
            title: 'No',
            render: () => <Col>{index++}</Col>,
        },
        {
            width: '50',
            key: 'screeningDate',
            title: 'Screening Date',
            render: ({ rowData }) => <>{timeFormat(rowData.screeningDate)}</>,
        },
        {
            width: '50',
            key: 'numberOfValidations',
            title: 'Number of Records',
        },
        {
            width: '50',
            key: 'progress',
            title: 'Progress',
        },
        {
            width: '50',
            key: 'status',
            title: 'Status',
        },
        {
            width: '50',
            title: 'Result',
            render: ({ rowData }) => (
                <Button
                    styleType={EButtonType.Outline}
                    size={EButtonSize.Normal}
                    onClick={() => {
                        downloadFile(rowData.id);
                    }}
                >
                    Export as CSV
                </Button>
            ),
        },
    ];

    const { isLoading } = useScreeningsGet({
        onSuccess: (data) => {
            const parsedData = data as screenings.TScreeningJob[];
            setFinalData(parsedData);
        },
    });

    const [mutation] = useScreeningCreatePost({
        onSuccess: () => {
            toast.success('Screening triggered successfully!');
        },
        onError: (e) => {
            toast.error(e as string);
        },
    });

    const triggerScreening = () => {
        if (currentSessionData?.id)
            return mutation({ adminId: '' + currentSessionData.id }); // To handle number being sent to Admin BE
        return;
    };

    return (
        <Root>
            <Col align={'bottom'} justify={'end'}>
                <Col align={'bottom'} justify={'end'} gap={0.2}>
                    <Button
                        styleType={EButtonType.Primary}
                        size={EButtonSize.Normal}
                        onClick={triggerScreening}
                    >
                        Trigger Screening
                    </Button>
                </Col>
            </Col>
            <MaterialTable<screenings.TScreeningJob>
                data={finalData}
                columns={columns}
                isLoading={isLoading}
            />
        </Root>
    );
};

export default ScreeningList;
